export const paginationConstant: any = {
    searchNumberItem: 20
}